import request from '@/utils/request'

// 查询常见问题列表
export function listCommonProblem(query) {
  console.log('query', query)
  return request({
    url: '/admin/common/problem/page',
    method: 'get',
    params: query
  })
}

// 查询常见问题详细
export function getCommonProblem(query) {
  return request({
    url: '/admin/common/problem/info',
    method: 'get',
    params: query
  })
}

// 新增常见问题
export function addCommonProblem(data) {
  return request({
    url: '/admin/common/problem/save',
    method: 'post',
    data: data
  })
}

// 修改常见问题
export function updateCommonProblem(data) {
  return request({
    url: 'admin/common/problem/edit',
    method: 'post',
    data: data
  })
}

// 删除常见问题
export function delCommonProblem(data) {
  return request({
    url: 'admin/common/problem/del',
    method: 'post',
    data
  })
}
